module.exports = __webpack_public_path__ + "img/TBB6.b54e0aac.jpg";